export default {
	root: '/api',
	//root: 'http://fargufa.is:7000/api',
	//root: 'https://fargufa.is/api',
}
